SNI.Application.addModule('class-promo', (context) => {
  return {
    behaviors: ['truncate'],
  };
});